// Custom hook to get the current's user session.

/* MUI */
import useMediaQuery from '@mui/material/useMediaQuery';

/* Hooks */
import { useSession } from 'hooks/redux/Selectors/session';

export const useUserTheme = () => {
    const searchParams = window.location.search;
    // For scheduled reports, we force the light theme so the PDF doesn't generate in all black.
    const forceLightTheme = new URLSearchParams(searchParams).get(
        'forceLightTheme'
    );

    const session = useSession();
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

    if (forceLightTheme) {
        return 'light';
    }

    const theme = session?.user?.theme || 'system';

    // All users have the theme set to system as a default, therefore, without the feature flag on, and
    // before the rebrand launch, we can only return the light file path for the image files.
    if ((theme === 'system' && prefersDarkMode) || theme === 'dark') {
        return 'dark';
    }

    return 'light';
};

export const getUserTheme = (theme) => {
    const prefersDarkMode =
        window.matchMedia &&
        window.matchMedia('(prefers-color-scheme: dark)').matches;

    if ((theme === 'system' && prefersDarkMode) || theme === 'dark') {
        return 'dark';
    }

    return 'light';
};
